import { styled } from '../jss-style';
import badgeStyle from './badge';

const useBadgeStyle = styled(badgeStyle, 'badge');
export { badgeStyle, useBadgeStyle };
export default useBadgeStyle;
